import type { FaireProductEntity } from "../../entity_types/product";

export const p_6zfffhpjt3: FaireProductEntity = {
  token: "p_6zfffhpjt3",
  type: "product",
  name: "Hawaiian Palaka & Shell Handmade Gift Tags",
  brandName: "Handmade Aloha Kauai",
  imageUrl:
    "https://cdn.faire.com/fastly/17f913fc0cd717e77009f1558757611c3051ffedec9fbdcfbed21c1950266988.jpeg",
  priceDollars: 1,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8155ad5787c439f176e0be7d47e974c17fba25bd1266c4fff93cf2ac1e96608f.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
